const u = (id, w = 1400) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const CONTACT = {
  phone: "7217602754",
  phoneDisplay: "+91 72176 02754",
  email: "info@trippytastic.com",
  address: "101, Khudiram Bose Marg, Pratap Nagar, Mayur Vihar, New Delhi, Delhi, 110091",
  whatsapp: "https://wa.me/917217602754?text=Hi%20Trippy%20Tastic%2C%20I%20have%20a%20query!",
  googleReviews: "https://share.google/MVrpfVQaSrXmJFwiC",
};

export const IMG = {
  kazbegi: u("1607068618611-c1ddadd316e3", 1800),
  caucasus: u("1593446798497-ad1485816c57"),
  tbilisiAerial: u("1704120724489-c2c16436f683"),
  tbilisiCity: u("1603350576276-24747f7bbf40"),
  tbilisiRiver: u("1603698873304-b052340d9719"),
  tbilisiOld: u("1608499781813-44bd498ed089"),
  tbilisiChurch: u("1707907776310-0f22fe906a08"),
  batumiPort: u("1625582175018-8fc4be59ac4f"),
  batumiWheel: u("1724593888371-61ffbc6fc49e"),
  kazbegiStream: u("1695562306302-4e28f84a6cc7"),
  ladakhBike: u("1581793745862-99fde7fa73d2"),
  ladakhFlags: u("1593118845043-359e5f628214"),
  sangam: u("1619837374214-f5b9eb80876d"),
  spiti: u("1653844573020-71f77a0ccb8c"),
  himachal: u("1578645546130-a8e4c5becb17"),
  meghalaya: u("1592842980386-4a17b5a2dea4"),
  rajasthan: u("1677294539972-74b0711da94c"),
  bali: u("1537996194471-e657df975ab4"),
  baliCliff: u("1746106191355-c100911b2c0a"),
  thai: u("1504214208698-ea1916a2195a"),
  vietnam: u("1746106147237-da9d080f56ff"),
  japan: u("1574236170880-fbbca132d83d"),
  kyoto: u("1493976040374-85c8e12f0c0e"),
  swiss: u("1527668752968-14dc70a27c95"),
  dubai: u("1651467606797-e1c660cf3fda"),
  baku: u("1602485487042-e5e9b528c389"),
  samarkand: u("1733586092622-1b3201e802a5"),
  prague: u("1600623471616-8c1966c91ff6"),
  dubrovnik: u("1414862625453-d87604a607e4"),
  safari: u("1623743424601-12be3807f99b"),
  newYork: u("1496588152823-86ff7695e68f"),
  machuPicchu: u("1587595431973-160d0d94add1"),
  sydney: u("1624138784614-87fd1b6528f8"),
  caribbean: u("1618064541372-289bdb6f5b7b"),
  chichenItza: u("1568402102990-bc541580b59f"),
  groupRocks: u("1539635278303-d4002c07eae3"),
  groupWall: u("1529156069898-49953e39b3ac"),
  groupSunset: u("1506869640319-fe1a24fd76dc"),
  groupHug: u("1511632765486-a01980e01a18"),
};

export const GEORGIA_PLACES = [
  { name: "Tbilisi", tag: "Old Town & sulphur baths", image: IMG.tbilisiAerial,
    text: "Wooden balconies, a cable car over the Mtkvari and late-night khachapuri." },
  { name: "Kazbegi", tag: "Gergeti under Mount Kazbek", image: IMG.kazbegi,
    text: "A 14th-century church on a ridge at 2,170 m with a glacier behind it." },
  { name: "Gudauri", tag: "Snow, slopes, paragliding", image: IMG.caucasus,
    text: "Ski lessons in winter, paragliding above green valleys in summer." },
  { name: "Batumi", tag: "Black Sea boulevard", image: IMG.batumiPort,
    text: "Palm-lined promenade, the Alphabet tower and evenings by the sea." },
  { name: "Kakheti", tag: "8,000 years of wine", image: IMG.tbilisiRiver,
    text: "Qvevri cellars, Signagi's walls and a long Georgian supra." },
];

export const CATEGORIES = [
  { key: "georgia", label: "Georgia Specials", note: "Our home turf", image: IMG.kazbegi, to: "/georgia" },
  { key: "group", label: "Group Trips", note: "Travel with your new crew", image: IMG.groupRocks, to: "/trips?category=group" },
  { key: "international", label: "International", note: "Passports out", image: IMG.baliCliff, to: "/trips?region=international" },
  { key: "india", label: "India Trips", note: "Mountains to deserts", image: IMG.ladakhBike, to: "/trips?region=india" },
  { key: "honeymoon", label: "Honeymoons", note: "Slow, private, for two", image: IMG.tbilisiRiver, to: "/trips?category=honeymoon" },
  { key: "weekend", label: "Weekend Getaways", note: "Friday night to Monday", image: IMG.himachal, to: "/trips?category=weekend" },
  { key: "corporate", label: "Corporate Offsites", note: "Teams that travel well", image: IMG.groupWall, to: "/contact?type=corporate" },
];

export const WHY_US = [
  { title: "Georgia, done properly", text: "Georgia is our speciality. Routes, stays and local partners we know first-hand, from Tbilisi to Batumi." },
  { title: "Crafted itineraries", text: "Famous sights and hidden corners, paced around your crew, your vibe and your budget." },
  { title: "Trip captains", text: "A captain travels with every group trip: part guide, part friend, fully in charge of the details." },
  { title: "End-to-end support", text: "Visa help, on-ground assistance and a team you can actually reach. You book, we handle the rest." },
  { title: "Transparent pricing", text: "Every inclusion and exclusion spelled out up front. No surprises mid-trip." },
  { title: "Good stays, good food", text: "Comfortable stays, reliable drivers and the best local meals we can find." },
];

export const GALLERY = [
  { src: IMG.groupSunset, label: "Kazbegi" }, { src: IMG.tbilisiCity, label: "Tbilisi" },
  { src: IMG.sangam, label: "Ladakh" }, { src: IMG.bali, label: "Bali" },
  { src: IMG.batumiWheel, label: "Batumi" }, { src: IMG.spiti, label: "Spiti" },
  { src: IMG.kyoto, label: "Kyoto" }, { src: IMG.thai, label: "Thailand" },
  { src: IMG.groupHug, label: "Himachal" }, { src: IMG.tbilisiChurch, label: "Tbilisi" },
  { src: IMG.meghalaya, label: "Meghalaya" }, { src: IMG.swiss, label: "Switzerland" },
];

export const MARQUEE_WORDS = ["Georgia", "Armenia", "Kazakhstan", "Uzbekistan", "Dubai", "Vietnam", "Bali", "Thailand", "Japan", "Switzerland", "Croatia", "Bhutan", "Georgia"];

const BY_ZONE = {
  "cis-caucasus": ["Georgia", "Armenia", "Azerbaijan", "Russia", "Belarus"],
  "central-asia": ["Kazakhstan", "Uzbekistan", "Kyrgyzstan", "Tajikistan", "Turkmenistan", "Mongolia"],
  "eastern-europe": ["Turkey", "Czechia", "Hungary", "Poland", "Romania", "Bulgaria", "Slovakia", "Estonia", "Latvia", "Lithuania"],
  balkans: ["Croatia", "Montenegro", "Albania", "Serbia", "Bosnia & Herzegovina", "North Macedonia", "Slovenia"],
  "schengen-europe": ["France", "Switzerland", "Italy", "Spain", "Greece", "Germany", "Netherlands", "Austria", "Portugal", "Belgium", "Iceland", "Norway", "Sweden", "Finland", "Denmark"],
  "southeast-asia": ["Bali", "Thailand", "Vietnam", "Singapore", "Malaysia", "Philippines", "Cambodia", "Laos"],
  "middle-east": ["Dubai", "Abu Dhabi", "Oman", "Jordan", "Qatar", "Saudi Arabia", "Bahrain"],
  "south-asia": ["India", "Bhutan", "Nepal", "Sri Lanka", "Maldives"],
  "east-asia": ["Japan", "South Korea", "China", "Hong Kong", "Taiwan"],
  africa: ["Kenya", "Tanzania", "South Africa", "Egypt", "Morocco", "Mauritius", "Seychelles"],
  "north-america": ["USA", "Canada"],
  "south-america": ["Peru", "Brazil", "Argentina", "Chile", "Colombia"],
  oceania: ["Australia", "New Zealand", "Fiji"],
  caribbean: ["Bahamas", "Jamaica", "Cuba", "Dominican Republic", "Barbados"],
  "central-america": ["Mexico", "Costa Rica", "Panama", "Belize", "Guatemala"],
};

export const COUNTRIES = Object.entries(BY_ZONE).flatMap(([zone, names]) => names.map((n) => [n, zone]));

export const DESTINATION_OPTIONS = ["Georgia", "Ladakh", "Spiti", "Meghalaya", "Himachal", "Rajasthan", "Bali", "Thailand", "Vietnam", "Japan", "Europe", "Other"];

export const ZONES = [
  { slug: "cis-caucasus", name: "CIS & Caucasus", hint: "Georgia, Armenia, Azerbaijan" },
  { slug: "central-asia", name: "Central Asia", hint: "Kazakhstan, Uzbekistan, Kyrgyzstan" },
  { slug: "eastern-europe", name: "Eastern Europe", hint: "Prague, Budapest, Krakow" },
  { slug: "balkans", name: "Balkans", hint: "Croatia, Montenegro, Albania" },
  { slug: "schengen-europe", name: "Schengen Europe", hint: "France, Switzerland, Italy" },
  { slug: "southeast-asia", name: "Southeast Asia", hint: "Bali, Thailand, Vietnam" },
  { slug: "middle-east", name: "Middle East", hint: "Dubai, Oman, Jordan" },
  { slug: "south-asia", name: "South Asia", hint: "India, Bhutan, Sri Lanka" },
  { slug: "east-asia", name: "East Asia", hint: "Japan, Korea" },
  { slug: "africa", name: "Africa", hint: "Kenya, Egypt, Morocco" },
  { slug: "north-america", name: "North America", hint: "USA, Canada" },
  { slug: "south-america", name: "South America", hint: "Peru, Brazil, Argentina" },
  { slug: "oceania", name: "Oceania", hint: "Australia, New Zealand" },
  { slug: "caribbean", name: "Caribbean", hint: "Bahamas, Jamaica, Cuba" },
  { slug: "central-america", name: "Central America", hint: "Costa Rica, Mexico, Panama" },
];

export const zoneName = (slug) => ZONES.find((z) => z.slug === slug)?.name || "";

export const REGION_PHOTOS = {
  "cis-caucasus": [IMG.kazbegi, "Gergeti Trinity, Georgia"], "central-asia": [IMG.samarkand, "Registan, Samarkand"],
  "eastern-europe": [IMG.prague, "Charles Bridge, Prague"], balkans: [IMG.dubrovnik, "Old Town, Dubrovnik"],
  "schengen-europe": [IMG.swiss, "Swiss Alps"], "southeast-asia": [IMG.baliCliff, "Nusa Penida, Bali"],
  "middle-east": [IMG.dubai, "Burj Khalifa, Dubai"], "south-asia": [IMG.ladakhBike, "Ladakh, India"],
  "east-asia": [IMG.japan, "Mount Fuji, Japan"], africa: [IMG.safari, "Masai Mara, Kenya"],
  "north-america": [IMG.newYork, "New York, USA"], "south-america": [IMG.machuPicchu, "Machu Picchu, Peru"],
  oceania: [IMG.sydney, "Sydney Opera House"], caribbean: [IMG.caribbean, "Caribbean coast"],
  "central-america": [IMG.chichenItza, "Chichén Itzá, Mexico"],
};

export const COUNTRY_PHOTOS = {
  Georgia: IMG.kazbegi, Azerbaijan: IMG.baku, Uzbekistan: IMG.samarkand, Czechia: IMG.prague, Croatia: IMG.dubrovnik,
  Switzerland: IMG.swiss, Bali: IMG.bali, Thailand: IMG.thai, Vietnam: IMG.vietnam, Dubai: IMG.dubai, India: IMG.ladakhBike,
  Japan: IMG.japan, Kenya: IMG.safari, USA: IMG.newYork, Peru: IMG.machuPicchu, Australia: IMG.sydney, Mexico: IMG.chichenItza,
  Bahamas: IMG.caribbean,
  Armenia: u("1770108866523-ed62000ae5e7", 160), Turkey: u("1695415683093-ae5f213ea898", 160),
  Kazakhstan: u("1530480667809-b655d4dc3aaa", 160), Russia: u("1563166796-befbbd534d1b", 160),
  Kyrgyzstan: u("1489421382202-f7ec0cfd96f7", 160), Hungary: u("1616432902940-b7a1acbc60b3", 160),
  Montenegro: u("1614122027743-50a9e6e8002f", 160), Greece: u("1613395877344-13d4a8e0d49e", 160),
  Italy: u("1552832230-c0197dd311b5", 160), France: u("1511739001486-6bfe10ce785f", 160),
  Spain: u("1728249960363-13079cc2c6f6", 160), Germany: u("1449452198679-05c7fd30f416", 160),
  Netherlands: u("1534351590666-13e3e96b5017", 160), Austria: u("1597086831879-756db15e81d3", 160),
  Portugal: "https://images.pexels.com/photos/20157706/pexels-photo-20157706.jpeg?auto=compress&w=160",
  Iceland: u("1621959721891-d297dfd9d6ee", 160), Norway: u("1663428520845-056989f8a664", 160),
  Singapore: u("1525625293386-3f8f99389edd", 160), Malaysia: u("1508062878650-88b52897f298", 160),
  Cambodia: u("1599283787923-51b965a58b05", 160), Oman: u("1599743777555-e362a2feab39", 160),
  Jordan: "https://images.pexels.com/photos/33283805/pexels-photo-33283805.jpeg?auto=compress&w=160",
  Nepal: u("1617469170169-55626c028519", 160), Bhutan: u("1638246439638-b37095b34879", 160),
  "Sri Lanka": u("1612862862126-865765df2ded", 160), Maldives: u("1514282401047-d79a71a590e8", 160),
  "South Korea": u("1583833008338-31a6657917ab", 160), China: u("1608037521277-154cd1b89191", 160),
  "Hong Kong": u("1576788369575-4ab045b9287e", 160), Egypt: u("1600520611035-84157ad4084d", 160),
  Morocco: u("1569383746724-6f1b882b8f46", 160), "South Africa": u("1588455471455-4b28e9ab3cd5", 160),
  Canada: u("1503614472-8c93d56e92ce", 160), Brazil: u("1518639192441-8fce0a366e2e", 160),
  "New Zealand": u("1591640040362-f55d95a6b2bc", 160), Cuba: u("1568322445389-495f4a7d20d4", 160),
  Belarus: u("1597986762540-bd1206e2a8b0", 160), Tajikistan: u("1590587347327-39c4ab1951e6", 160),
  Turkmenistan: u("1764505879412-bc7e77ad1bde", 160), Mongolia: u("1535728534313-e206f59bed23", 160),
  Romania: u("1695045088081-1f37125905a2", 160), Bulgaria: u("1722447145262-3ff87e068c95", 160),
  Slovakia: u("1562779346-e43d30d2e647", 160), Estonia: u("1564951537954-29dd59397b90", 160),
  Latvia: u("1567669721460-221b82865ee0", 160),
  Lithuania: "https://images.unsplash.com/flagged/photo-1569359268637-aea1d77614c9?auto=format&fit=crop&w=160&q=80",
  Poland: "https://images.pexels.com/photos/36950143/pexels-photo-36950143.jpeg?auto=compress&w=160",
  Serbia: "https://images.pexels.com/photos/29263051/pexels-photo-29263051.jpeg?auto=compress&w=160",
  "Bosnia & Herzegovina": u("1544329095-a7c19df83018", 160), "North Macedonia": u("1619371620133-1c4b489a0569", 160),
  Slovenia: u("1478088913771-e3a36f50bb63", 160),
  Albania: "https://images.pexels.com/photos/33079342/pexels-photo-33079342.jpeg?auto=compress&w=160",
  Belgium: u("1601993305512-a73859a41ec2", 160), Sweden: u("1588653818221-2651ec1a6423", 160),
  Finland: u("1614090691187-983c32a930c9", 160), Denmark: u("1513622470522-26c3c8a854bc", 160),
  Philippines: u("1519485837477-db36b0c4ad7a", 160), Laos: u("1693039880389-62840065382c", 160),
  "Abu Dhabi": u("1590273089302-ebbc53986b6e", 160), Qatar: u("1669300884869-e6e11c67c031", 160),
  "Saudi Arabia": u("1565552645632-d725f8bfc19a", 160), Bahrain: u("1748066768504-99532da7d1e9", 160),
  Taiwan: u("1598935898639-81586f7d2129", 160),
  Tanzania: "https://images.pexels.com/photos/15904775/pexels-photo-15904775.jpeg?auto=compress&w=160",
  Mauritius: u("1686740348132-c8883cba00a0", 160), Seychelles: u("1553829176-61484f865ac3", 160),
  Argentina: u("1637580980556-085dee659c7e", 160), Chile: u("1570075017462-b5478b3abfff", 160),
  Colombia: u("1534943441045-1009d7cb0bb9", 160), Fiji: u("1655719647300-5142977bfa79", 160),
  Jamaica: u("1437719417032-8595fd9e9dc6", 160), "Dominican Republic": u("1705507972578-78537a2dda73", 160),
  Barbados: u("1682289570915-5d6e41ade8bc", 160), "Costa Rica": u("1664532869454-53ac5942d959", 160),
  Panama: u("1598041543955-0d88c390f3b5", 160), Belize: u("1722761478075-720dc58e63d1", 160),
  Guatemala: u("1628128594359-25d5e30661dd", 160),
};

export const STATS = [
  { value: 500, suffix: "+", label: "Travel Agents" },
  { value: 100, suffix: "+", label: "Corporate Clients" },
  { value: 1, suffix: " Year+", label: "Experience" },
  { value: 99, suffix: "%", label: "Success Rate" },
  { value: 50000, suffix: "+", label: "Applications Processed", repeat: true },
];

export const PARTNERS = [
  { name: "ixigo", logo: "/brand/partners/ixigo.png", h: "h-12 sm:h-14" },
  { name: "AerTicket", logo: "/brand/partners/aerticket.png", h: "h-5 sm:h-7" },
  { name: "Dafodill", logo: "/brand/partners/dafodill.png", h: "h-9 sm:h-11" },
  { name: "Unthinkable", logo: "/brand/partners/unthinkable.png", h: "h-6 sm:h-8" },
];
